export const FEATURE_FLAGS = {
    ENABLE_BILLSBY: process.env.REACT_APP_ENABLE_BILLSBY === 'true',
    ENABLE_SUPPLIER_DATABASE: process.env.REACT_APP_ENABLE_SUPPLIER_DATABASE !== 'false',
    ENABLE_SALES_OPPORTUNITIES: process.env.REACT_APP_ENABLE_SALES_OPPORTUNITIES !== 'false',
    ENABLE_GROW_BUSINESS: process.env.REACT_APP_ENABLE_GROW_BUSINESS !== 'false',
    ENABLE_ACE: process.env.REACT_APP_ENABLE_ACE === 'true' || process.env.NODE_ENV === 'development',
    ENABLE_POLICY_AGREEMENT: process.env.REACT_APP_ENABLE_POLICY_AGREEMENT === 'true', // Enabled for dev and stage, disabled for prod
    ENABLE_REMOTE_ACCESS: process.env.REACT_APP_ENABLE_REMOTE_ACCESS === 'true',
};

export const isFeatureEnabled = (featureName) => FEATURE_FLAGS[featureName] === true;


// WEBPACK FOOTER //
// ./src/config/featureFlags.js